const HeaderHamburgerToggle = ({ handleClick }: { handleClick: () => void }) => (
    <div className="tw-cursor-pointer" onClick={handleClick}>
        <svg width="22" height="19" xmlns="http://www.w3.org/2000/svg">
            <g
                stroke="#4B4F54"
                strokeWidth="2.585"
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
                strokeOpacity=".804"
            >
                <path d="M2 1.431h18M2 9.186h17.571M2 16.942h17.571"></path>
            </g>
        </svg>
    </div>
);

export default HeaderHamburgerToggle;
